.box {
    border: 1px solid var(--mantine-color-gneis-2);
    border-radius: var(--mantine-radius-sm);
    width: 100%;
}

.header {
    padding: var(--mantine-spacing-md) var(--mantine-spacing-sm);
    border-bottom: 1px solid var(--mantine-color-gneis-2);
}

.title {
    text-transform: uppercase;
    font-size: var(--mantine-font-size-xs);
    font-weight: 700;
    color: var(--mantine-color-dark-4);
    margin: 0;
}

.description {
    margin-top: calc(var(--mantine-spacing-2xs) / 2);
}

.content {
}
